module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ui-confirm', {
    ref: "logout",
    attrs: {
      "title": _vm.$t('header.logout-confirm.title'),
      "confirm-button-text": _vm.$t('header.logout-confirm.yes'),
      "deny-button-text": _vm.$t('header.logout-confirm.no'),
      "closeOnConfirm": true
    },
    on: {
      "confirm": _vm.logoutConfirmed
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('header.logout-confirm.text')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 column"
  }, [_c('back-links')], 1), _vm._v(" "), _c('div', {
    staticClass: "small-4 column"
  }, [_c('h1', {
    staticClass: "app-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 column"
  }, [_c('ul', {
    staticClass: "nav-links clearfix"
  }, [(_vm.$store.state.user && _vm.$store.state.user.hasEshop) ? _c('li', [_c('a', {
    staticClass: "cart-link ui-icon-button logout-link float-right ui-icon-button--type-normal ui-icon-button--color-default ui-icon-button--size-normal",
    attrs: {
      "href": _vm.ShopUrl,
      "title": "EShop"
    }
  }, [_c('ui-icon', {
    attrs: {
      "color": "default",
      "type": "normal",
      "icon": "shopping_cart"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('ui-icon-button', {
    staticClass: "logout-link float-right",
    attrs: {
      "color": "default",
      "type": "normal",
      "icon": "lock_open"
    },
    on: {
      "click": function($event) {
        _vm.showConfirm('basicConfirm')
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "hide-for-large search-link float-right",
    attrs: {
      "to": {
        name: 'search'
      },
      "tag": "li"
    }
  }, [_c('ui-icon-button', {
    attrs: {
      "color": "default",
      "type": "normal",
      "icon": "search"
    }
  })], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41ab4dbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Nav.vue
// module id = 296
// module chunks = 2